/**
 * @param {OfferWeb.ClientSideUser | null} user
 * @returns {import('@tidal/styles-header').User | null}
 */
export default function tidalHeaderUser(user) {
    if (!user) {
        return null;
    }

    return {
        userName: user.userName,
    };
}
